import React, { createContext, useContext, useState, useEffect } from 'react';
import { authUser, projectFirestore } from '../firebase/config';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

// الصلاحيات المتاحة
export const ALL_PERMISSIONS = [
    { key: 'upload', label: 'رفع الصور' },
    { key: 'delete', label: 'حذف الصور' },
    { key: 'editUI', label: 'تعديل واجهة الموقع' },
    { key: 'manageUsers', label: 'إضافة وحذف مستخدم' },
    { key: 'changePassword', label: 'تغيير كلمة المرور' },
    { key: 'changeSource', label: 'تغيير مصدر الصور' },
    { key: 'manageAccounts', label: 'إدارة حسابات الخدمات' },
    { key: 'manageCovers', label: 'إدارة أغلفة الأقسام' },
    { key: 'manageNews', label: 'إدارة الأخبار والإعلانات' },
    { key: 'editFooter', label: 'تعديل الفوتر والمعلومات' },
];

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = authUser.onAuthStateChanged(async (firebaseUser) => {
            if (firebaseUser) {
                setUser(firebaseUser);
                // جلب بيانات المستخدم من Firestore
                const doc = await projectFirestore.collection('adminUsers').doc(firebaseUser.uid).get();
                if (doc.exists) {
                    setUserProfile(doc.data());
                } else {
                    // أول مستخدم يسجل دخول يصبح مدير بكل الصلاحيات
                    const snap = await projectFirestore.collection('adminUsers').get();
                    if (snap.empty) {
                        const adminData = {
                            email: firebaseUser.email,
                            displayName: firebaseUser.email.split('@')[0],
                            role: 'admin',
                            permissions: {
                                upload: true,
                                delete: true,
                                editUI: true,
                                manageUsers: true,
                                changePassword: true,
                                changeSource: true,
                                manageAccounts: true,
                                manageCovers: true,
                                manageNews: true,
                                editFooter: true,
                            },
                            createdAt: new Date().toISOString(),
                        };
                        await projectFirestore.collection('adminUsers').doc(firebaseUser.uid).set(adminData);
                        setUserProfile(adminData);
                    } else {
                        // مستخدم غير مسجل في النظام - لا يملك صلاحيات
                        setUserProfile(null);
                    }
                }
            } else {
                setUser(null);
                setUserProfile(null);
            }
            setLoading(false);
        });
        return () => unsub();
    }, []);

    // التحقق من صلاحية معينة — المدير (admin) يملك كل الصلاحيات تلقائياً
    const hasPermission = (perm) => {
        if (!userProfile || !userProfile.permissions) return false;
        if (userProfile.role === 'admin') return true;
        return userProfile.permissions[perm] === true;
    };

    const isAdmin = () => {
        return userProfile && userProfile.role === 'admin';
    };

    const logout = () => {
        authUser.signOut();
    };

    const value = {
        user,
        userProfile,
        loading,
        hasPermission,
        isAdmin,
        logout,
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}
